import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <div className="min-h-screen">
      <Header />

      <section className="py-16 px-6 bg-background min-h-[600px]">
        <div className="container mx-auto max-w-6xl">
          <h1 className="text-5xl font-bold mb-16 text-center">Kontakta oss</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed">
                Vill du veta mer? Vänligen fyll i kontaktformuläret eller
                kontakta oss:
              </p>
              <div>
                <p className="font-semibold text-lg">
                  Telefonnummer: +46 (0) 73 928 86 89
                </p>
              </div>
              <div>
                <p className="font-semibold text-lg">
                  Öppettider - 9:00 - 18:00
                </p>
              </div>
              <div>
                <p className="font-semibold text-lg">
                  Mejl: info@orbitcablecam.com
                </p>
              </div>
            </div>

            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
